import { render, staticRenderFns } from "./VeterinaryImages.vue?vue&type=template&id=e8b4deb2&scoped=true&%23all=true"
import script from "./VeterinaryImages.vue?vue&type=script&lang=js"
export * from "./VeterinaryImages.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryImages.vue?vue&type=style&index=0&id=e8b4deb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b4deb2",
  null
  
)

export default component.exports